import List from '../../../components/Purchasing/Remittance/List'
import PaymentRequestList from '../../../components/Purchasing/Remittance/PaymentRequestList'
import RemittanceModal from '../../../components/Purchasing/Remittance/AddRemittance/RemittanceModal'
import PageTitle from '../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Modal, Row, Tabs } from 'antd'
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { get } from 'lodash'

const { Content } = Layout
const { TabPane } = Tabs

function Remittance(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="/#/purchasing/remittance/">Purchasing</Breadcrumb.Item>
              <Breadcrumb.Item>Remittance</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle title={'Remittance'} subtitle={'Remittance'} color={'#427035'} iconType={'dollar'} />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <RemittanceModal {...props} />
            <Tabs
              defaultActiveKey={get(props, 'location.hash') || '#paymentRequest'}
              onChange={(key) => props.history.push(key)}>
              <TabPane tab="Payment Request" key="#paymentRequest">
                <PaymentRequestList {...props} />
              </TabPane>
              <TabPane tab="Remittance" key="#remittance">
                <List {...props} />
              </TabPane>
            </Tabs>
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

Remittance.propTypes = {}
Remittance.defaultProps = {}

export default withRouter(Remittance)
